module.exports = __webpack_public_path__ + "static/media/img_feature_photo2@2x.c27d2b95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_feature_photo2@2x.jpg
// module id = 797
// module chunks = 0